import { render, staticRenderFns } from "./processdetails.vue?vue&type=template&id=3c0bc069&scoped=true"
import script from "./processdetails.vue?vue&type=script&lang=js"
export * from "./processdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bc069",
  null
  
)

export default component.exports